import { createFileRoute } from "@tanstack/react-router";

import { LiveFlowCanvas } from "@/components/canvas/live-flow-canvas";

export const Route = createFileRoute("/$workspace/flow")({
  head: () => ({ meta: [{ title: "Flow — Dravian Horizon" }] }),
  component: FlowPage,
});

function FlowPage() {
  const { workspace } = Route.useParams();
  return <LiveFlowCanvas workspaceId={workspace} />;
}
